exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expand-enter-active,.expand-leave-active{transition-property:opacity,height;transition:height 1s ease-in-out;overflow:hidden}.expand-enter,.expand-leave-to{height:0;opacity:0}", ""]);

// exports
